<template>
  <div class="button-container" ref="headerbuttons" :class="{'has-all-buttons': options.showBackBtn && options.showCreateBtn}">
    <div class="button-wrapper" :class="{ fixed: isFixed, 'table-view': selectedView == 0, 'user-view': ['main', 'group-trainings'].includes(currentRouteName)}">
          <div class="container-item left" v-if="selectedView==0">
            <div
                class="create-new"
                @click="goToLinkGen"
                :class="{ active: options.loadingItem }"
                v-if="options.showLinkBtn"
            >
                <span>Linkų generavimas</span>
                <div class="group-plus">
                    <PlusNarrowSvg v-if="!options.loadingItem" />
                    <LoadingBubbleSvg v-else-if="options.loadingItem" class="spinning" />
                </div>
            </div>
        </div>



        <div class="container-item left" :class="{'has-no-content': !options.showBackBtn && !options.showCreateBtn && !options.showSearchContentToggle, 'has-no-create-btn': !options.showCreateBtn}">
            <!-- <span 
              class="go-back" 
              @click="goBack" 
              v-if="options.showBackBtn && (!$store.state.isOnlyTrainingGroup || options.type == 'edit')"
            >
                <ArrowLeftSvg /> 
                {{ toLocal("generic.back") }}
            </span> -->
            <span 
              class="go-back" 
              @click="goBack" 
              v-if="options.showBackBtn"
            >
                <ArrowLeftSvg /> 
                {{ toLocal("generic.back") }}
            </span>
            <!-- <CustomDropdown
                  :list="[{key:'training',label:toLocal('generic.training')}, {key:'physical', label:toLocal('home_edit.physical_training')}]"
                  key-label="key"
                  value-label="label"
                  :compareChosen="{}"
                  :options="{
                      closeOnClick: true,
                      checkbox: false,
                      customDDWidth: '90%',
                      customMaxHeight: '300px',
                      initial:  'trainings.create_new',
                      containerClass: 'create-training-dropdown create-new',
                      showCreateNewBtn:false
                  }"
                   v-if="options.showCreateBtn"
                  @elClicked="(type, event) => options.createItemAction(type)"
              >
                  <template v-slot:arrow >
                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.933058 1.05806C1.17714 0.813981 1.57286 0.813981 1.81694 1.05806L6.375 5.61612L10.9331 1.05806C11.1771 0.813981 11.5729 0.813981 11.8169 1.05806C12.061 1.30214 12.061 1.69786 11.8169 1.94194L6.81694 6.94194C6.57286 7.18602 6.17714 7.18602 5.93306 6.94194L0.933058 1.94194C0.688981 1.69786 0.688981 1.30214 0.933058 1.05806Z" fill="#7D7D7D"/>
                    </svg>
                  </template>
              </CustomDropdown> -->
              <CustomDropdown
                v-if="filteredCreateList && filteredCreateList.length > 0"
                :list="filteredCreateList"
                key-label="key"
                value-label="value"
                class="training-type-dropdown"
                :compareChosen="{}"
                :options="{
                    closeOnClick: true,
                    checkbox: false,
                    customDDWidth: 'initial',
                    customDDMaxWidth: '250px',
                    customDDMinWidth: '100%',
                    customMaxHeight: '300px',
                    initial: 'test_side.create',
                    containerClass: 'condition-filter-dropdown '+getContrast(),
                    searchBar: false,
                    left:true,
                    showCreateNewBtn: false,
                    valueWidthType: 'dynamic'
                }"
                @elClicked="(type, event) => options.createItemAction(type)"
            ></CustomDropdown>
            <!-- <TrainingCreateModal :items="filteredCreateList" @selectItem="(s_item, event) => options.createItemAction(s_item.type)"/> -->
            <!-- <div
                class="create-new"
                @click="options.createItemAction('training')"
                :class="{ active: options.loadingItem }"
                v-if="options.showCreateBtn"
            >
                <span>{{ toLocal(options.createItemBtnText) }}</span>
                <div class="group-plus">
                    <PlusNarrowSvg v-if="!options.loadingItem" />
                    <LoadingBubbleSvg v-else-if="options.loadingItem" class="spinning" />
                </div>
            </div> -->
            <div
                class="create-new"
                @click="options.createGroupItemAction"
                :class="{ active: options.loadingGroupItem }"
                v-if="options.showGroupCreateBtn"
            >
                <span>{{ toLocal(options.createGroupBtnText) }}</span>
                <div class="group-plus">
                    <PlusNarrowSvg v-if="!options.loadingGroupItem" />
                    <LoadingBubbleSvg v-else-if="options.loadingGroupItem" class="spinning" />
                </div>
            </div>
            <div class="toggle-deep-search" v-if="isMobileWindow() && !isFixed && $store.state.system_settings.showDeepSearch">
              <span>
                {{toLocal('search.search_in_content')}}
              </span>
              <ToggleButton
                  :toggledState="deepSearchMode"
                  :height="32"
                  :width="64"
                  :innerHeight="28"
                  :innerWidth="28"
                  theme="search"
                  toggleDirection="right"
                  @changeState="deepSearchMode = $event ? 1 : 0"
                />
            </div>
        </div>
        <div class="container-item middle" v-if="!options.showCreateBtn">
            <TrainingSearch :mode="options.mode" :deepSearchMode="deepSearchMode" class="center-middle" />
        </div>
        <div class="container-item right" :class="{'has-no-content': !options.showCreateBtn}">
            <TrainingSearch :mode="options.mode" :deepSearchMode="deepSearchMode" v-if="options.showCreateBtn" />
            <div class="view-btn-container" v-if="['edit', 'edit-group'].includes(currentRouteName)">
              <div class="toggle-deep-search" v-if="!isMobileWindow() && !isFixed && $store.state.system_settings.showDeepSearch">
                <span>
                  {{toLocal('search.search_in_content')}}
                </span>
                <ToggleButton
                    :toggledState="deepSearchMode"
                    :height="32"
                    :width="64"
                    :innerHeight="28"
                    :innerWidth="28"
                    theme="search"
                    toggleDirection="right"
                    @changeState="deepSearchMode = $event ? 1 : 0"
                  />
              </div>
            
              <div class="toggle-container" v-if="selectedView==0">
                <span>
                  {{toLocal('trainings.created_by_me')}}
                </span>
                <ToggleButton
                  :toggledState="selectedMode"
                  :height="32"
                  :width="64"
                  :innerHeight="28"
                  :innerWidth="28"
                  theme="bidirectional"
                  @changeState="selectedMode = $event ? 1 : 0"
                />
                <span>
                  {{toLocal('training_edit.test_questions_all')}}
                </span>
              </div>
              <div class="view-btn" :class="{active: selectedView == 0}" @click="selectedView=0">
                <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.14474 1.10526C4.14474 0.698317 4.46285 0.368421 4.85526 0.368421H17.1711C17.5635 0.368421 17.8816 0.698317 17.8816 1.10526C17.8816 1.51221 17.5635 1.84211 17.1711 1.84211H4.85526C4.46285 1.84211 4.14474 1.51221 4.14474 1.10526Z" fill="#4D4D4D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.02632 1.10526C4.02632 0.630492 4.39745 0.245614 4.85526 0.245614H17.1711C17.6289 0.245614 18 0.630492 18 1.10526C18 1.58003 17.6289 1.96491 17.1711 1.96491H4.85526C4.39745 1.96491 4.02632 1.58003 4.02632 1.10526ZM4.85526 0.491228C4.52825 0.491228 4.26316 0.766141 4.26316 1.10526C4.26316 1.44439 4.52825 1.7193 4.85526 1.7193H17.1711C17.4981 1.7193 17.7632 1.44439 17.7632 1.10526C17.7632 0.766141 17.4981 0.491228 17.1711 0.491228H4.85526Z" fill="#4D4D4D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.14474 7C4.14474 6.59305 4.46285 6.26316 4.85526 6.26316H17.1711C17.5635 6.26316 17.8816 6.59305 17.8816 7C17.8816 7.40695 17.5635 7.73684 17.1711 7.73684H4.85526C4.46285 7.73684 4.14474 7.40695 4.14474 7Z" fill="#4D4D4D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.02632 7C4.02632 6.52523 4.39745 6.14035 4.85526 6.14035H17.1711C17.6289 6.14035 18 6.52523 18 7C18 7.47477 17.6289 7.85965 17.1711 7.85965H4.85526C4.39745 7.85965 4.02632 7.47477 4.02632 7ZM4.85526 6.38596C4.52825 6.38596 4.26316 6.66088 4.26316 7C4.26316 7.33912 4.52825 7.61404 4.85526 7.61404H17.1711C17.4981 7.61404 17.7632 7.33912 17.7632 7C17.7632 6.66088 17.4981 6.38596 17.1711 6.38596H4.85526Z" fill="#4D4D4D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.14474 12.8947C4.14474 12.4878 4.46285 12.1579 4.85526 12.1579H17.1711C17.5635 12.1579 17.8816 12.4878 17.8816 12.8947C17.8816 13.3017 17.5635 13.6316 17.1711 13.6316H4.85526C4.46285 13.6316 4.14474 13.3017 4.14474 12.8947Z" fill="#4D4D4D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.02632 12.8947C4.02632 12.42 4.39745 12.0351 4.85526 12.0351H17.1711C17.6289 12.0351 18 12.42 18 12.8947C18 13.3695 17.6289 13.7544 17.1711 13.7544H4.85526C4.39745 13.7544 4.02632 13.3695 4.02632 12.8947ZM4.85526 12.2807C4.52825 12.2807 4.26316 12.5556 4.26316 12.8947C4.26316 13.2339 4.52825 13.5088 4.85526 13.5088H17.1711C17.4981 13.5088 17.7632 13.2339 17.7632 12.8947C17.7632 12.5556 17.4981 12.2807 17.1711 12.2807H4.85526Z" fill="#4D4D4D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0.118421 1.10526C0.118421 0.562668 0.542572 0.122807 1.06579 0.122807H1.07526C1.59848 0.122807 2.02263 0.562668 2.02263 1.10526C2.02263 1.64786 1.59848 2.08772 1.07526 2.08772H1.06579C0.542572 2.08772 0.118421 1.64786 0.118421 1.10526Z" fill="#4D4D4D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.10526C0 0.494843 0.47717 0 1.06579 0H1.07526C1.66388 0 2.14105 0.494843 2.14105 1.10526C2.14105 1.71568 1.66388 2.21053 1.07526 2.21053H1.06579C0.47717 2.21053 0 1.71568 0 1.10526ZM1.06579 0.245614C0.607974 0.245614 0.236842 0.630492 0.236842 1.10526C0.236842 1.58003 0.607974 1.96491 1.06579 1.96491H1.07526C1.53308 1.96491 1.90421 1.58003 1.90421 1.10526C1.90421 0.630492 1.53308 0.245614 1.07526 0.245614H1.06579Z" fill="#4D4D4D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0.118421 7C0.118421 6.4574 0.542572 6.01754 1.06579 6.01754H1.07526C1.59848 6.01754 2.02263 6.4574 2.02263 7C2.02263 7.5426 1.59848 7.98246 1.07526 7.98246H1.06579C0.542572 7.98246 0.118421 7.5426 0.118421 7Z" fill="#4D4D4D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0 7C0 6.38958 0.47717 5.89474 1.06579 5.89474H1.07526C1.66388 5.89474 2.14105 6.38958 2.14105 7C2.14105 7.61042 1.66388 8.10526 1.07526 8.10526H1.06579C0.47717 8.10526 0 7.61042 0 7ZM1.06579 6.14035C0.607974 6.14035 0.236842 6.52523 0.236842 7C0.236842 7.47477 0.607974 7.85965 1.06579 7.85965H1.07526C1.53308 7.85965 1.90421 7.47477 1.90421 7C1.90421 6.52523 1.53308 6.14035 1.07526 6.14035H1.06579Z" fill="#4D4D4D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0.118421 12.8947C0.118421 12.3521 0.542572 11.9123 1.06579 11.9123H1.07526C1.59848 11.9123 2.02263 12.3521 2.02263 12.8947C2.02263 13.4373 1.59848 13.8772 1.07526 13.8772H1.06579C0.542572 13.8772 0.118421 13.4373 0.118421 12.8947Z" fill="#4D4D4D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0 12.8947C0 12.2843 0.47717 11.7895 1.06579 11.7895H1.07526C1.66388 11.7895 2.14105 12.2843 2.14105 12.8947C2.14105 13.5052 1.66388 14 1.07526 14H1.06579C0.47717 14 0 13.5052 0 12.8947ZM1.06579 12.0351C0.607974 12.0351 0.236842 12.42 0.236842 12.8947C0.236842 13.3695 0.607974 13.7544 1.06579 13.7544H1.07526C1.53308 13.7544 1.90421 13.3695 1.90421 12.8947C1.90421 12.42 1.53308 12.0351 1.07526 12.0351H1.06579Z" fill="#4D4D4D"/></svg>
              </div>
              <div class="view-btn" :class="{active: selectedView == 1}" @click="selectedView=1">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.56757 1.45946C1.95558 1.45946 1.45946 1.95558 1.45946 2.56757V15.4324C1.45946 16.0444 1.95558 16.5405 2.56757 16.5405H15.4324C16.0444 16.5405 16.5405 16.0444 16.5405 15.4324V2.56757C16.5405 1.95558 16.0444 1.45946 15.4324 1.45946H2.56757ZM0 2.56757C0 1.14954 1.14954 0 2.56757 0H15.4324C16.8505 0 18 1.14954 18 2.56757V15.4324C18 16.8505 16.8505 18 15.4324 18H2.56757C1.14954 18 0 16.8505 0 15.4324V2.56757Z" fill="#4D4D4D"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.78378 5.13514C5.42554 5.13514 5.13514 5.42554 5.13514 5.78378C5.13514 6.14202 5.42554 6.43243 5.78378 6.43243C6.14202 6.43243 6.43243 6.14202 6.43243 5.78378C6.43243 5.42554 6.14202 5.13514 5.78378 5.13514ZM3.67568 5.78378C3.67568 4.61951 4.61951 3.67568 5.78378 3.67568C6.94806 3.67568 7.89189 4.61951 7.89189 5.78378C7.89189 6.94806 6.94806 7.89189 5.78378 7.89189C4.61951 7.89189 3.67568 6.94806 3.67568 5.78378Z" fill="#4D4D4D"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6757 6.43243C12.8692 6.43243 13.0548 6.50931 13.1917 6.64617L17.7863 11.2408C18.0712 11.5257 18.0712 11.9878 17.7863 12.2728C17.5013 12.5577 17.0392 12.5577 16.7543 12.2728L12.6757 8.19416L3.08356 17.7863C2.79859 18.0712 2.33655 18.0712 2.05157 17.7863C1.76659 17.5013 1.76659 17.0393 2.05157 16.7543L12.1597 6.64617C12.2965 6.50931 12.4821 6.43243 12.6757 6.43243Z" fill="#4D4D4D"/>
                </svg>
              </div>
            </div>
            <div class="toggle-deep-search" v-if="!isMobileWindow() && !isFixed && !['edit', 'edit-group'].includes(currentRouteName) && $store.state.system_settings.showDeepSearch">
                <span>
                  {{toLocal('search.search_in_content')}}
                </span>
                <ToggleButton
                    :toggledState="deepSearchMode"
                    :height="32"
                    :width="64"
                    :innerHeight="28"
                    :innerWidth="28"
                    theme="search"
                    toggleDirection="right"
                    @changeState="deepSearchMode = $event ? 1 : 0"
                  />
              </div>
        </div>
         <div class="container-item" v-if="isFixed && options.showCreateBtn">
        </div>
        
    </div>
  </div>
</template>

<script>
import TrainingSearch from "@/components/layout/TrainingSearch.vue";
import ToggleButton from "@/components/layout/emails/ToggleButton.vue";
import PlusNarrowSvg from "@/assets/images/icons/plus-narrow-white.svg?inline";
import LoadingBubbleSvg from "@/assets/images/icons/loading-bubble.svg?inline";
import ArrowLeftSvg from "@/assets/images/icons/homeEdit/arrow-go-back-16-8.svg?inline";
import CustomDropdown from "@/components/layout/elements/CustomDropdown.vue";
import TrainingCreateModal from '@/components/layout/modals/TrainingCreateModal.vue'

export default {
    props:{
        options: {
            type: Object,
            default(){return {}}
        },
        
    },
    components:{
        TrainingSearch,
        ToggleButton,
        CustomDropdown,
        TrainingCreateModal,
        PlusNarrowSvg,
        LoadingBubbleSvg,
        ArrowLeftSvg
    },
    data(){
        return{
            isHeaderInView: true,
            selectedView: 1,
            selectedMode: 1,
            deepSearchMode: 0
        }
    },
    computed:{
      isFixed(){
        return !this.isHeaderInView && (this.options.selectedTrainingStats ? this.options.selectedTrainingStats==-1 : true)
      },
      currentRouteName() {
          return this.$route.name;
      },
      filteredCreateList(){
      // if(this.trainingGroup.path && this.trainingGroup.path.length > 4) return false;
      // if (this.$store.state.user_role == 'admin') return true;
      // if (this.hasPermission('trainings.create') && this.hasPermission('trainings.training_group_create')) {
      //   if (this.$store.state.user_permissions['trainings.edit_in_groups'] && this.$store.state.user_permissions['trainings.training_group_create']) {
      //     let ids = this.$store.state.user_permissions['trainings.edit_in_groups'].items;
      //     if (ids.includes(this.trainingGroup.id) || this.$store.state.user_permissions['trainings.edit_in_groups'].all_selected) {
      //       return true;
      //     }
      //     else return false;
      //   }
      //   else {
      //     return true;
      //   }
      // }
      // return false
      if(!this.options.trainingGroup) return []
      if(!this.$store.state.system_settings) return []
      if(!this.$store.state.system_settings.trainingTypes) return []
      return this.$store.state.system_settings.trainingTypes.filter(el =>{
          if(el.key == 'training_group'){
            if(this.options.trainingGroup.path && this.options.trainingGroup.path.length > 4) return false;
            if (this.$store.state.user_role == 'admin') return true;
            if (this.hasPermission('trainings.create') && this.hasPermission('trainings.training_group_create')) {
              if (this.$store.state.user_permissions['trainings.edit_in_groups'] && this.$store.state.user_permissions['trainings.training_group_create']) {
                let ids = this.$store.state.user_permissions['trainings.edit_in_groups'].items;
                if (ids.includes(this.options.trainingGroup.id) || this.$store.state.user_permissions['trainings.edit_in_groups'].all_selected) {
                  return true;
                }
                else return false;
              }
              else {
                return true;
              }
            }
          }
          else{
            if (this.$store.state.user_role == 'admin') return true;
            if (this.hasPermission('trainings.create')) {
              if (this.$store.state.user_permissions['trainings.edit_in_groups']) {
                let ids = this.$store.state.user_permissions['trainings.edit_in_groups'].items;
                if (ids.includes(this.options.trainingGroup.id) || this.$store.state.user_permissions['trainings.edit_in_groups'].all_selected) {
                  return true;
                }
                else return false;
              }
              else {
                return true;
              }
            }
            return false
          }
          return false
        })
      }
    },
    watch:{
      selectedView(){
        this.$emit('selectView', this.selectedView)
      },
      selectedMode(){
        this.$emit('selectMode', this.selectedMode)
      }
    },
    mounted(){
      if(this.options.selectedView){
        this.selectedView = this.options.selectedView
      }
      window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy(){
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods:{
        goToLinkGen(){
          this.$router.push("/timedLink")
        },
         handleScroll() {
            if (this.$refs["headerbuttons"] != undefined) {
                if (this.$refs["headerbuttons"].getBoundingClientRect().top >= 95) {
                    this.isHeaderInView = true;
                } else {
                    this.isHeaderInView = false;
                }
            }
        },
        addNewTraining(group){
            this.$emit('addNewTraining', group)
        },
        goBack(){
            this.$emit('goBack');
        },
  
    }
}
</script>

<style lang="scss" scoped>
.button-wrapper{
    display: flex;
    align-items: center;
    width: 100%;
    @media (max-width: 768px), (max-width: 1000px) and (max-height: 512px){
      flex-direction: column;
      gap: 20px;
      width: 85%;
      .container-item{
        width: 100%;
        .create-new{
          width: 100%;
          justify-content: flex-start;
        }
        &.has-no-create-btn{
          .go-back{
            top:0;
          }
        }
      }
      .right{
        padding-left: 0;
        
      }
      .left{
        padding-right: 0;
      }
      .has-no-content{
        display: none;
      }
      &.fixed{
        .has-no-content{
          display: flex;
        }
      }
    }
}
.fixed{
    width: 50%;
    position: fixed;
    z-index: 1001;
    top: 0;
    height: 11vh;
    max-height: 11vh;
    .go-back{
        display: none;
    }
    @media (max-width: 768px), (max-width: 1000px) and (max-height: 512px){
      background: white;
      width: 100%;
      flex-direction: row;
      .left{
        flex: 0;
      }
      .right{
        flex: 3;
      }
    
    }
    .create-new{
      display: none;
    }
    .left{
      // width: 0;
      // flex:0;
    }
    .right{
      padding-left: 0;
      
    }
    .view-btn-container{
      display: none;
    }
    .training-type-dropdown {
      display: none;
    }
}
.button-container{
  width: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 48px;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  @media(max-width: 768px){
    width: 100%;
    min-height: 100px;
    margin-top: 10px;
    &.has-all-buttons{
      margin-top: 65px;
    }
  }
}
.go-back{
    position: absolute;
    left: 0;
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    height: clamp(32px, 5vh, 38px);
    transition: 0.25s;
    color: rgba(125, 125, 125, 1);
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
    border-radius: 30px;
    padding: 6.5px 16px;
    svg{
        margin-right: 12px;
        stroke: rgba(125, 125, 125, 1);
        stroke-width: 2;
        transition: 0.25s;
        path{
        border: 2px solid #333333;
        }
    }
    &:hover{
        background: #FFFFFF;
        color: rgba(51, 51, 51, 1);
        svg{
        stroke: rgba(51, 51, 51, 1);
        box-sizing: border-box;
        }
    }
    @media(max-width: 768px){
      height: clamp(32px, 5vh, 38px);
      left: calc(15% / 2);
      top: -55px;
    }
}
.left,.right{
    display: flex;
    min-height: 32px;

}
.right{
    padding-left: 20px;
    justify-content: space-between;
}
.left{
    justify-content: flex-end;
    padding-right: 20px;
}

.middle{
    display: flex;
    width: 100%;
    justify-content: center;
}
.header-btns{
    display: flex;

}
.container-item{
    display: flex;
    flex: 1;
   &.left{
    gap: 1.5rem;
   }

}
.table-view{
  .container-item{
    &.left{
      flex: 2;
    }
    &.right{
      flex: 3;
    }
  }
}
.user-view{
  .container-item{
    &.right{
      justify-content: flex-end;
    }
  }
}

.create-new {
    padding: 4px 14px;
    padding-right: 46px;
    height: clamp(32px, 5vh, 38px);
    color: white;
    background: #4D4D4D;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.16);
    border-radius: 30px;
    display: flex;
    position: relative;
    user-select: none;
    transition: 0.25s;
    &:hover {
      background: #e2e2e2;
      color: black;
      .group-plus {
        svg {
          stroke: black;
          fill: black;
        }
      }
    }
    &.active {
      background: #e2e2e2;
      color: black;
      transition: 0.1s;
      .group-plus {
        svg {
          stroke: black;
          fill: black;
        }
      }
    }
    .group-plus {
        position: absolute;
        right: 14px;
        top: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        align-items: center;
        @media(max-width: 768px){
            height: 65%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        svg {
            width: 16px;
            height: 16px;
            stroke: white;
            fill: white;
        }
    }
    span{
        display: flex;
        align-items: center;
        font-size: 16px;
        white-space: nowrap;
    }
    &:active {
      font-weight: bolder;
    }
    cursor: pointer;
    font-size: 16px;
    @media (max-width: 1680px) {
    //   width: 30%;
    }
    @media (max-width: 1280px) {
    }
    @media (max-width: 900px) {
    }
    @media(max-width: 768px), (max-width: 1000px) and (max-height: 512px) {
      margin-right: 0;
      min-height: 35px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    
}
@media(max-width: 1280px) and (min-width: 769px){
  .header-btn-wrapper{
    max-height: 32px;
    .go-back{
      font-size: 14px;
      height: 100%;
    }
  }
  .header-btns{
    max-height: 32px;
    width: 90%;
    gap: 20px;
    &:not(.fixed){
      .create-new{
        font-size: 14px;
        display: flex;
        align-items: center;
        margin-right: 0;
        height: clamp(32px, 5vh, 38px);
        span{
          flex-grow: 1;
        }
        .group-plus{
          position: initial;
          width: 16px;
          height: 16px;
        }
      }
      .search-bar{
        display: flex;
        align-items: center;
        box-sizing: border-box;
        max-height: 32px;
        .search-input{  
          font-size: 14px;
          flex-grow: 1;
        }
        .search-icon{
          position: initial;
          height: 20px;
        }
      }
    }
    &.fixed{
      max-width: 50%;
      right: 20%;
      gap: 10px;
      .create-new {
        height: fit-content;
        padding-right: 16px;
        text-align: start;
        font-size: 14px;
        height: 40px;
        width: 50%;
        margin-right: 0;
        display: flex;
        align-items: center;
        span{
          flex-grow: 1;
        }
        .group-plus{
          height: 16px;
          width: 16px;
          position: initial;
        }
      }
      .search-bar{
        width: 50%;
        padding-right: 16px;
        display: flex;
        width: fit-content;
        align-items: center;

        .search-input{
          font-size: 14px;
          width: fit-content;
          flex-grow: 1;
          width: 90%;
        }
        .search-icon{
          position: initial;
          height: 20px;
        }
      }
      
    }
  }
}
.view-btn-container{
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 12px;
}
.view-btn{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 20px;
  background: #FFF;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.16);
  cursor: pointer;
  transition: all 0.3s;
  height: 32px;
  min-width: 32px;
  width: 32px;
  min-height: 32px;
  &:hover{
    background: #E2E2E2;
  }
  &.active,&:active{
    background: #4D4D4D;
    svg{
      path{
        fill: white;
      }
    }
    &:hover{
      background: #7D7D7D;
    }
  }
}
.toggle-container{
  display: flex;
  align-items: center;
  margin-right: 34px;
  span{
    color: #333;
    text-align: center;
    text-overflow: ellipsis;
    font-family: var(--main-site-font);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    margin: 0 6px;
  }
}

</style>
<style lang="scss">
.center-middle{
    &.search-container{
        justify-content: center;
        align-items: center;
        width: 225px;
        &:focus-within{
          width: 100%;
          .input-container{
            width: 100%;
          }
        }
        &.focused{
          .input-container{
            width: 100%;
          }
        }
    }
    .dropdown-container{
      // max-width: 500px;
    }
   
    .input-container{
        justify-content: center;
        width: 225px;
        transition: width 0.3s;
        &:focus-within {
            input{

                width: 100%;
            }
        }
        input{
            &.focused{
                width: 100%;
            }
        }
  
    }
    @media (max-width: 768px), (max-width: 1000px) and (max-height: 512px){
      &.search-container{
        width: 85vw;
      }
      .input-container{
   
          &:focus-within {
              input{
                  width: 100%;
              }
          }
          input{
              &.focused{
                  width: 100%;
              }
          }
    
      }
    }
}

.fixed{
  .input-container{
    input{
      box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.36);
    }
  }
  @media(max-width: 768px){
    .search-container{
      width: 78vw;
    }
    .input-container{
      input{
        width: 100%;
      }
    }
  }
}
.button-wrapper{
  @media (max-width: 768px), (max-width: 1000px) and (max-height: 512px){
    .input-container{
      width: 100%;
      input{
        width: 100%;
      }
    }
  }
}
.toggle-deep-search{
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  span{
    color: #333333;
    font-size: clamp(15px, 1.2vw, 16px);
  }
}
.create-training-dropdown{
  display: flex;
  align-items: center;
  border-radius: 30px;
  min-width: 11rem;
  &.dropdown-container{
    .dropdown-initial{
      color: white;
      span{
        max-width: 100%;
      }
    }
    .initial,.reverse{
      svg{
        path{
          fill: white;
        }
      }
    }
    .dropdown-extended:not(.left){
      right:5%;
    }
    .dropdown-extended .dropdown-option span{
      max-width: 100%;
    }
  }
}
.training-type-dropdown{
  background-color: #4D4D4D;
  max-width: 250px;
  width: 11.3rem;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  z-index: 9;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);
  &.open{
    z-index: 99;
  }
  &.condition-filter-dropdown.dropdown-container:not(.no-padding-no-bg){
    background-color:#4D4D4D;
    padding: 8px 12px;
    border-radius: 20px;
  }
  &.dropdown-container .dropdown-initial{
    color: white;
    // font-size: 20px;
    font-size: 16px;
  }
  &.dropdown-container{
    .dropdown-extended .dropdown-option{
      margin: 0;
      padding: 8px 12px;
    }
    .dropdown-extended .dropdown-option:hover{
      background-color: #E2E2E2;
      font-weight: 500;
    }
  }
}
</style>